
import useRedux from "./useRedux";

const useNetwork = () => useRedux(state => state.blockchain.network);

export default useNetwork;
